<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.SendOnlineManifestInvitationEmail')"
    width="425px"
    append-to-body
    class="app-main-inner-row"
    :close-on-click-modal="false"
  >
    <div>
      <span>
        <b>{{ $t('SeaExport.PleaseConfirmEmailAddress') }}</b>
      </span>
      <cargo-combo-box
        v-model="toEmail"
        :allow-create="true"
        :clearable="true"
        :options="contacts"
        style="width: 270px;"
        :label-function="labelFunction"
        value-field="email"
        :forbid-values="['']"
        @clear="onClear"
      />
    </div>
    <div slot="footer" style="margin:0 auto;width:fit-content">
      <el-button type="primary" @click="sendHandler">{{ $t('SeaExport.Send') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('CargoMsg.Cargo_Close') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import cargoComboBox from '@/components/Cargo/Common/cargoComboBox'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { getContactList } from '@/api/partner/contact'
import { ManifestInfo } from '@/class/model/booking/ManifestInfo'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'

export default {
  name: 'ManifestInvitationDialog',
  components: { cargoComboBox, cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    invitationType: { type: Number, required: true },
    job: { type: Object, required: true },
    manifestInfo: { type: Object, required: true },
    callback: { type: Function, default: null }
  },
  data() {
    return {
      innerVisible: false,
      contacts: [],
      toEmail: ''
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal && this.job.customerId) {
        this.getContacts()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.contacts = []
        this.toEmail = ''
      }
    }
  },
  async created() {
    if (this.visible) {
      this.innerVisible = true
      this.getContacts()
    }
  },
  methods: {
    onClear(val) {
      this.toEmail = ''
    },
    getContacts() {
      if (this.job.customerId) {
        const company = getCacheListByKey(basicCacheKeys.basic_data_Company).filter(p => p.cmpIdx === this.job.customerId)[0]
        if (company) {
          getContactList({ companyUuid: company.uuid }).then(res => {
            if (!res.data || !res.data.list) return
            for (const item of res.data.list) {
              if (item.email) this.contacts.push(item)
            }
            if (this.contacts && this.contacts.length > 0) this.toEmail = this.contacts[0].email
          })
          return
        }
      }
      this.contacts = []
    },
    labelFunction(item) {
      return `【${item.contactPerson}】${item.email}`
    },
    async sendHandler() {
      if (!this.toEmail) {
        this.$message.warning(this.$t('SeaExport.MailboxCannotBeEmpty'))
        return
      }
      if (this.invitationType === 0) {
        const manifestInfoModel = new ManifestInfo(this.manifestInfo)
        await manifestInfoModel.sendCfmManifestEmail(this.job.uuid, this.toEmail)
        if (this.manifestInfo.uuid) {
          manifestInfoModel.reload()
        }
      } else {
        await ManifestInfo.sendShareCfmManifestEmail(this.toEmail)
      }
      // todo 对按钮点击进行埋点
      // LogStores.sendFunctionClickLogStoresByLabel(this.$t('SeaExport.ShippingPreConfigurationInformationManifest'))
      setTimeout(() => {
        this.$message.success(this.$t('SeaExport.TheSentToTheIt'))
        if (this.callback) {
          this.callback()
        }
      }, 500)
      this.innerVisible = false
    }
  }
}
</script>

<style>
</style>
